import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
interface CTAStripProps {
  heading?: string;
  subheading?: string;
}
export function CTAStrip({
  heading = 'Ready to Book Your Collection?',
  subheading = 'Get a free, no-obligation quote in minutes. We reply within 30 minutes.'
}: CTAStripProps) {
  return <section className="py-16 px-4" style={{
    background: 'linear-gradient(135deg, #1B8F4B 0%, #0F5D2E 100%)'
  }} data-id="element-37">
      <div className="max-w-4xl mx-auto text-center" data-id="element-38">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{
        fontFamily: 'Montserrat, sans-serif'
      }} data-id="element-39">
          {heading}
        </h2>
        <p className="text-green-100 text-lg mb-8" data-id="element-40">{subheading}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-41">
          <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-bold text-[#1B8F4B] bg-white hover:bg-green-50 transition-all duration-200 hover:shadow-lg" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-42">
            Get a Free Quote <ArrowRight className="w-4 h-4" data-id="element-43" />
          </Link>
          <a href="tel:+447405641227" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-bold text-white border-2 border-white/50 hover:border-white hover:bg-white/10 transition-all duration-200" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-44">
            <Phone className="w-4 h-4" data-id="element-45" /> 07405 641227
          </a>
        </div>
      </div>
    </section>;
}